class VideoSection {
  constructor() {
    this.filters = document.querySelectorAll('.video-section .filters button');
    this.grid = document.querySelector('.video-section .grid.home-grid');
    if (!this.grid) return;
    this.iso = new Isotope(this.grid, {
      itemSelector: '.item',
      layoutMode: 'fitRows',
    });
    
    this.init();
    this.bindEvents();
  }

  init() {
    this.filters[0].classList.add('active');
    setTimeout( () => {
      this.updateGrid();
    }, 200);
  }

  bindEvents() {
    this.filters.forEach( filterButton => {
      filterButton.addEventListener('click', (event) => {
        this.handleFilterButton(event);
        this.updateGrid();
      });
    });
  }

  handleFilterButton(event) {
    event.preventDefault();

    // Remove active from all buttons
    this.filters.forEach( filter => {
      filter.classList.remove('active');
    });

    // Add active to this filter
    event.target.classList.add('active');
  }

  updateGrid() {
    let selectedFilter = document.querySelector('.video-section .filters button.active');
    if (selectedFilter.length == 0) return;
    let selectedFilterValue = selectedFilter.dataset.filter;

    this.iso.arrange({ filter: selectedFilterValue });

  }
}